import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import PaymenttypeModel from '../paymenttype/paymenttype-model';
import TransactionModel from '../transaction/transaction-model';

export default class TransactionpaymentModel {
    id: number;
    name: string;
    description: string;
    status: string;
    value: number;
    paymentdate: any;
    paymentdateFmt: string;
    paymenttype: any;
    paymenttypeCaption: string;
    paymenttypeAccountNo: string;
    image: any;
    imageId: number;
    imageUrl: string;    
    transaction: any;
    transactionCaption: string;
    transactionTotal: number;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        this.value = datarow.value;
        this.paymentdate = datarow.paymentdate;
        this.paymentdateFmt = AppService.dateFormat(datarow.paymentdate, 'y-m-d h:n');
        let paymenttype = datarow.paymenttype?.data? new PaymenttypeModel(datarow.paymenttype?.data) : datarow.paymenttype;
        this.paymenttype = paymenttype?.id;
        this.paymenttypeCaption = paymenttype?.name;
        this.paymenttypeAccountNo = paymenttype?.description;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        let transaction = datarow.transaction?.data? new TransactionModel(datarow.transaction?.data) : datarow.transaction;
        this.transaction = transaction?.id;
        this.transactionCaption = transaction?.name;
        this.transactionTotal = transaction?.total;
    } 

    public static endPoint: string = 'transaction-payments';
    public static endPointMedia: string = 'api::transaction-payment.transaction-payment';
    public static endPointFilterList = (transactionId: number) => {
        return ('?populate=*&filters[transaction]=' + transactionId);
    }
    public static url: string = '/transactionpayment';

    public static caption: string = 'Payment Detail';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        value: 0,
        paymentdate: AppService.dateCurrent(),
        paymentdateFmt: '',
        paymenttype: null,
        paymenttypeCaption: '',
        paymenttypeAccountNo: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        transaction: null,
        transactionCaption: '',
        transactionTotal: 0,
        }
    }
        
    public static validations = [
        { name: 'paymenttype', nameAlias: 'Type', required: true },
    ]
    
    public static columns = [
        { name: 'paymenttypeCaption', caption: '' },
        { name: 'paymenttypeAccountNo', caption: '' },
        { name: 'value', caption: '', type: 'money' },
              
    ]

    public static columnPicklist = [
        { name: 'paymenttypeCaption', caption: 'Type' },
        { name: 'paymenttypeAccountNo', caption: 'Account No' },
        { name: 'value', caption: 'Amount', type: 'money' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
        
}